import request from '@/utils/request'

/**
 * 查询店铺营业时段配置
 * 服务码 shop.queryShopBusinessTime（Task 8 既有码，C 端/商户态共用；仅返回正常状态配置）
 * @param {Object} params 查询参数（shopId 必填）
 * @returns {Promise} Promise对象，data 为 [{sbtId, shopId, dayType, startTime, endTime, statusCd, createTime}]
 */
export function queryShopBusinessTime(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopBusinessTime',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 覆盖式保存店铺营业时段配置（REQ20260904014，整页三页签一次性提交，后端先按 shop_id 物理删存量再逐条插入）
 * 注意：times 键必须存在；空数组=清空语义（覆盖式保存先删后插 0 条，恢复店铺默认营业时间，
 * 终审补齐 2026-09-04），前端全空时需二次确认后再提交
 * @param {Object} data 保存报文（{shopId, times:[{dayType, startTime, endTime}]}）
 * @returns {Promise} Promise对象
 */
export function saveShopBusinessTime(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.saveShopBusinessTime',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除单条店铺营业时段配置（REQ20260904014，物理删除，按 sbtId 定位并核定店铺归属）
 * @param {Object} data 删除报文（{sbtId}）
 * @returns {Promise} Promise对象
 */
export function deleteShopBusinessTime(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.deleteShopBusinessTime',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
